import request from "@/utils/request";

export default function remove(id) {
    return request({
        url: `/storeProductSpecification/agency/remove/`+id,
        method: 'get',
    })
}
